import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldCheck, Clock, MapPin, Phone } from "lucide-react";

const COLS = [
  {
    title: "Rent a Car",
    links: [["Short-Term Rental", "/rent-a-car"], ["Monthly Rental", "/monthly"], ["International Rentals", "/international"], ["Offers & Promotions", "/offers"]],
  },
  {
    title: "Why Europcar",
    links: [["Our Fleet", "/fleet"], ["Our Network & Branches", "/network"], ["Locations & Branch Finder", "/locations"], ["The Europcar Promise", "/promise"], ["Renter's Guide", "/renters-guide"], ["Blog & Driving Guides", "/blog"]],
  },
  {
    title: "Company",
    links: [["About Us", "/about"], ["Partner With Us", "/partner-with-us"], ["Help & Support", "/help"], ["Contact Us", "/contact"], ["Modify or Cancel a Booking", "/modify-reservation"], ["Account / Vehicle", "/account"]],
  },
];

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="mt-auto" data-testid="site-footer">
      <svg viewBox="0 0 1440 70" preserveAspectRatio="none" className="block w-full h-[50px] sm:h-[70px]" aria-hidden="true">
        <path d="M0,70 C360,0 720,90 1080,30 C1260,4 1380,20 1440,10 L1440,70 Z" fill="#009900" opacity="0.9" />
        <path d="M0,70 C400,20 800,80 1440,25 L1440,70 Z" fill="#144733" />
      </svg>
      <div className="bg-[#144733] text-white -mt-px">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="inline-block bg-white rounded-lg p-2.5 mb-4" data-testid="footer-logo">
              <img src="/europcar-logo.jpg" alt="Europcar" className="h-11 w-auto rounded" />
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              {t("Dubai and the Northern Emirates. Daily, weekly and monthly rentals across the UAE, delivered to your door or ready at 14 branches.")}
            </p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> 800 EUROPCAR (800 38767227)</li>
              <li className="flex items-center gap-2"><Clock className="w-4 h-4" /> {t("24/7 roadside assistance included")}</li>
              <li className="flex items-center gap-2"><MapPin className="w-4 h-4" /> {t("14 branches across the UAE")}</li>
              <li className="flex items-center gap-2"><ShieldCheck className="w-4 h-4" /> {t("Comprehensive cover with CDW")}</li>
            </ul>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="heading-upper text-sm mb-4 text-[#FFDC00]">{t(col.title)}</h4>
              <ul className="space-y-2 text-sm text-white/70">
                {col.links.map(([label, to]) => (
                  <li key={to + label}><Link to={to} className="hover:text-white transition-colors">{t(label)}</Link></li>
                ))}
                {col.title === "Company" && (
                  <li key="careers">
                    <a href="https://egmg-premium.emergent.host/careers#openings" target="_blank" rel="noreferrer"
                      className="hover:text-white transition-colors" data-testid="footer-careers-link">{t("Careers")}</a>
                  </li>
                )}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/50">
            <span>{t("© 2026 Europcar Dubai & Northern Emirates. Demo platform — payments simulated. This site uses essential cookies only (sign-in session).")}</span>
            <nav className="flex flex-wrap gap-x-4 gap-y-1" data-testid="footer-legal-links">
              <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms-link">{t("Terms & Conditions")}</Link>
              <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy-link">{t("Privacy Policy")}</Link>
              <Link to="/cookies" className="hover:text-white transition-colors" data-testid="footer-cookies-link">{t("Cookie Policy")}</Link>
            </nav>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-4 text-xs text-white/40">
            {t("Minimum driver age 21 · Prices shown incl. 5% VAT · \"Or similar\" model policy")}
          </div>
        </div>
      </div>
    </footer>
  );
};
